import { render } from "./RealEstatePage.vue?vue&type=template&id=075625b6&ts=true"
import script from "./RealEstatePage.vue?vue&type=script&lang=ts"
export * from "./RealEstatePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__